import { c as _c } from "react/compiler-runtime";
import { ReactNode } from 'react';
import { styled, SxProps, Theme } from '@classify/react-core-components/styles';
import Box from '@classify/react-core-components/Box';
interface Props {
  children: ReactNode;
  isMobileWide?: boolean;
  sx?: SxProps<Theme>;
}
const ActionsWrapper = styled(Box, {
  shouldForwardProp: prop => !['isMobileWide'].includes(prop as string)
})<{
  isMobileWide?: boolean;
}>(({
  theme: {
    spacing,
    breakpoints
  },
  isMobileWide
}) => ({
  display: 'flex',
  gap: spacing(2),
  flexWrap: 'wrap',
  alignItems: 'flex-start',
  ...(isMobileWide && {
    alignItems: 'stretch',
    flexDirection: 'column-reverse',
    [breakpoints.up('md')]: {
      flexDirection: 'row-reverse',
      justifyContent: 'flex-start'
    }
  })
}));
export default function ActionsContainer(t0) {
  const $ = _c(10);
  let children;
  let isMobileWide;
  let otherProps;
  let sx;
  if ($[0] !== t0) {
    ({
      children,
      isMobileWide,
      sx,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = isMobileWide;
    $[3] = otherProps;
    $[4] = sx;
  } else {
    children = $[1];
    isMobileWide = $[2];
    otherProps = $[3];
    sx = $[4];
  }
  let t1;
  if ($[5] !== children || $[6] !== isMobileWide || $[7] !== otherProps || $[8] !== sx) {
    t1 = <ActionsWrapper isMobileWide={isMobileWide} {...otherProps} {...sx}>{children}</ActionsWrapper>;
    $[5] = children;
    $[6] = isMobileWide;
    $[7] = otherProps;
    $[8] = sx;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  return t1;
}